import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useImperativeHandle } from 'react';
import { usePolygon } from './usePolygon';
export * from './usePolygon';
export default /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
    polygon,
    setPath
  } = usePolygon(props);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => setPath(props.path), [props.path]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useImperativeHandle(ref, () => _extends({}, props, {
    polygon
  }), [polygon, props]);
  return null;
});